import { defs as activitiDefs, activiti } from "./activiti";

import { defs as aiderDefs, aider } from "./aider";

import { defs as appCenterDefs, appCenter } from "./appCenter";

import { defs as authDefs, auth } from "./auth";

import { defs as basicsDefs, basics } from "./basics";

import { defs as busDefs, bus } from "./bus";

import { defs as businessDefs, business } from "./business";

import { defs as crawlerDefs, crawler } from "./crawler";

import { defs as crmDefs, crm } from "./crm";

import { defs as deviceDefs, device } from "./device";

import { defs as escaDefs, esca } from "./esca";

import { defs as fulfilmentDefs, fulfilment } from "./fulfilment";

import { defs as kolDefs, kol } from "./kol";

import { defs as mailDefs, mail } from "./mail";

import { defs as srmDefs, srm } from "./srm";

import { defs as mnsDefs, mns } from "./mns";

import { defs as omsDefs, oms } from "./oms";

import { defs as omsFlowDefs, omsFlow } from "./omsFlow";

import { defs as platDataFlowDefs, platDataFlow } from "./platDataFlow";

import { defs as rmsDefs, rms } from "./rms";

import { defs as stockDefs, stock } from "./stock";

import { defs as tmsDefs, tms } from "./tms";

import { defs as ucenterDefs, ucenter } from "./ucenter";

import { defs as walmartDefs, walmart } from "./walmart";

import { defs as wmsDefs, wms } from "./wms";

import { defs as reportDefs, report } from "./report";
(window as any).defs = {
  activiti: activitiDefs,
  aider: aiderDefs,
  appCenter: appCenterDefs,
  auth: authDefs,
  basics: basicsDefs,
  bus: busDefs,
  business: businessDefs,
  crawler: crawlerDefs,
  crm: crmDefs,
  device: deviceDefs,
  esca: escaDefs,
  fulfilment: fulfilmentDefs,
  kol: kolDefs,
  mail: mailDefs,
  srm: srmDefs,
  mns: mnsDefs,
  oms: omsDefs,
  omsFlow: omsFlowDefs,
  platDataFlow: platDataFlowDefs,
  rms: rmsDefs,
  stock: stockDefs,
  tms: tmsDefs,
  ucenter: ucenterDefs,
  walmart: walmartDefs,
  wms: wmsDefs,
  report: reportDefs,
};
(window as any).API = {
  activiti,
  aider,
  appCenter,
  auth,
  basics,
  bus,
  business,
  crawler,
  crm,
  device,
  esca,
  fulfilment,
  kol,
  mail,
  srm,
  mns,
  oms,
  omsFlow,
  platDataFlow,
  rms,
  stock,
  tms,
  ucenter,
  walmart,
  wms,
  report,
};
